import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

function Forgot({ onSwitch }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    setError('');
    if (!email.includes('@')) return setError('Enter a valid email');
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (e) {
      setError('Could not send reset email. Check your email address.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-5">
      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-7 w-full max-w-sm relative">

        {/* X button */}
        <button
          onClick={() => onSwitch('landing')}
          className="absolute top-4 right-4 text-gray-600 hover:text-white transition-all text-lg">
          ✕
        </button>

        {/* Logo */}
        <div className="flex items-center gap-2 mb-6">
          <svg width="26" height="26" viewBox="0 0 100 130" fill="none">
            <defs>
              <linearGradient id="fg" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#f2c832"/>
                <stop offset="100%" stopColor="#e8496a"/>
              </linearGradient>
            </defs>
            <path d="M58 4L84 4L84 10L68 10L68 54L84 54L84 62L52 126L42 126L62 72L44 72L44 62L16 62L16 54L32 54L32 10L16 10L16 4L42 4L42 54L58 54Z" fill="url(#fg)"/>
          </svg>
          <span className="font-bold text-sm bg-gradient-to-r from-yellow-400 to-pink-500 bg-clip-text text-transparent">ArcBolt</span>
        </div>

        {!sent ? (
          <>
            <h2 className="text-xl font-bold text-white mb-1">Reset password</h2>
            <p className="text-xs text-gray-500 mb-6">Enter your email and we'll send a reset link</p>

            <div className="mb-5">
              <label className="text-xs text-gray-500 uppercase tracking-wide mb-1 block">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full bg-gray-950 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-yellow-500 transition-all placeholder-gray-700"
              />
            </div>

            {error && <div className="bg-red-950 border border-red-800 rounded-lg px-3 py-2 text-xs text-red-400 mb-4">{error}</div>}

            <button
              onClick={handleReset}
              disabled={loading}
              className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all disabled:opacity-40 mb-3"
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>

            <p className="text-xs text-gray-600 text-center">
              <span onClick={() => onSwitch('login')} className="text-yellow-400 cursor-pointer hover:underline">← Back to sign in</span>
            </p>
          </>
        ) : (
          <>
            <div className="text-center">
              <div className="text-4xl mb-4">✉</div>
              <h2 className="text-xl font-bold text-white mb-2">Check your email</h2>
              <p className="text-xs text-gray-400 leading-relaxed mb-6">
                Reset link sent to <span className="text-white font-medium">{email}</span>. Follow the instructions to reset your password.
              </p>
              <button
                onClick={() => onSwitch('login')}
                className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all"
              >
                Back to sign in
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default Forgot;